import { ServiceRequestScreen } from '@/modules/support';
import React from 'react';

export default function ServiceRequest() {
    return <ServiceRequestScreen />;
}

